import SoftwareProjects from "../components/SoftwareProjects";
import Navbar from "../components/Navbar";
import React, { useState, useEffect } from "react";
import Background from "../components/Background.js";
import back from "../assets/icons/back.svg";

import freshnest from "../assets/images/projects/freshnest.png";
import emailtester from "../assets/images/projects/emailtester.png";
import xtools from "../assets/images/projects/xtools.png";
import easyorder from "../assets/images/projects/easyorder.png";
import neohacking from "../assets/images/projects/neohacking.png";
import portfolio from "../assets/images/projects/portfolio.png";
import myclubnet from "../assets/images/projects/myclubnet.png";
import leureblue from "../assets/images/projects/leureblue.png";
import noteai from "../assets/images/projects/noteai.png";

const Software = () => {
  const handleClick = () => {
    alert("Clicked");
  };
  // const [slideShowStatus, setSlideShowStatus] = useState(true);

  return (
    <>
      <div className="overflow-x-hidden">
        <Background />
        <Navbar type="software" image={back} />

        {/* Content */}

        <main
          id="main"
          className="flex flex-col h-[100dvh] pt-28 px-2 md:px-20"
        >
          {/* header */}
          <div className="flex flex-row justify-between mb-4 text-left text-white">
            <div className="duration-300 transition-all">
              <h1 className="text-[#a8a8a8] sm:text-sm  text-xs uppercase">
                Project
              </h1>
            </div>
            <div className="duration-300 transition-all">
              <h1 className="text-[#a8a8a8] sm:text-sm  text-xs uppercase">
                Client
              </h1>
            </div>
            <div className="duration-300 transition-all">
              <h1 className="text-[#a8a8a8] sm:text-sm  text-xs uppercase">
                Type
              </h1>
            </div>
            <div className="duration-300 transition-all">
              <h1 className="text-[#a8a8a8] sm:text-sm  text-xs uppercase"></h1>
            </div>
          </div>
          <hr />
          <SoftwareProjects
            project="FreshNest"
            description="Grocery Delivery Platform"
            year={2024}
            client="FreshNest"
            image={freshnest}
            type="Web App"
            link="https://blackbox.leureblue.com"
          />
          <SoftwareProjects
            project="Email Tester"
            description="Learn more"
            year={2023}
            client="clubnet"
            github_link="https://github.com/chr1stian-og/email-tester"
            image={emailtester}
            type="Web App"
            link="https://email.christianmacarthur.com"
          />
          <SoftwareProjects
            project="Xtools"
            description="Learn more"
            year={2023}
            client="clubnet"
            github_link="https://github.com/chr1stian-og/xtools"
            image={xtools}
            type="Web App"
            link="https://xtools.christianmacarthur.com"
          />
          <SoftwareProjects
            project="Leureblue"
            description="Learn more"
            year={2023}
            client="Leureblue"
            image={leureblue}
            type="website"
            link="https://leureblue.com"
          />
          <SoftwareProjects
            project="EasyOrder"
            description="Learn more"
            year={2022}
            client="BetaX Consultants"
            github_link="https://github.com/chr1stian-og/EasyOrder"
            image={easyorder}
            type="Web App"
            link="https://easyorder.christianmacarthur.com"
          />
          <SoftwareProjects
            project="Neohacking"
            description="Learn more"
            year={2022}
            client="Americo JR."
            github_link="https://github.com/chr1stian-og/neo-hacking"
            image={neohacking}
            type="website"
            link="https://americojunior.com"
          />
          <SoftwareProjects
            project="Portfolio"
            description="Learn more"
            year={2024}
            client="Personal"
            github_link="https://github.com/chr1stian-og/portfolio2024"
            image={portfolio}
            type="website"
            link="https://christianmacarthur.com"
          />
          <SoftwareProjects
            project="MyClubnet"
            description="Learn more"
            year={2023}
            client="Clubnet"
            image={myclubnet}
            type="web Dashboard"
            link="https://my.clubnet.mz"
          />
          <SoftwareProjects
            project="note.ai"
            description="Learn more"
            year={2023}
            client="LeureBlue"
            image={noteai}
            github_link="https://github.com/chr1stian-og/noteai"
            type="Web App"
            link="https://my.clubnet.mz"
          />
        </main>
      </div>
    </>
  );
};

export default Software;
